"use client";

import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { usePathname } from "@/i18n/navigation";
import { useSearchParams } from "next/navigation";

export default function TermsAndConditions() {
  const t = useTranslations("TermsAndConditions");
  const [activeMenu, setActiveMenu] = useState<string | null>(null);

  const handlerActiveMenu = (menu: string) => {
    setActiveMenu(activeMenu === menu ? "" : menu);
  };

  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      handlerActiveMenu(hash.replace("#", ""));

      setTimeout(() => {
        const el = document.getElementById(hash.replace("#", ""));

        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }, [pathname, searchParams]);

  return (
    <>
      <div className="accordion">
        <div
          className={`accordion_item ${activeMenu === "introduction" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("introduction")}
        >
          <div className="accordion_item__header">{t("introduction.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <p>{t("introduction.item1")}</p>
              <p>{t("introduction.item2")}</p>
              <p>{t("introduction.item3")}</p>
            </div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "contract-alterations" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("contract-alterations")}
        >
          <div className="accordion_item__header">{t("contractAlterations.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("contractAlterations.item1")}</li>
                <li>{t("contractAlterations.item2")}</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "legal-requirements" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("legal-requirements")}
        >
          <div className="accordion_item__header">{t("legalRequirements.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("legalRequirements.item1")}</li>
                <li>{t("legalRequirements.item2")}</li>
                <li>{t("legalRequirements.item3")}</li>
                <li>{t("legalRequirements.item4")}</li>
                <li>{t("legalRequirements.item5")}</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "creating-an-account" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("creating-an-account")}
          id={"creating-an-account"}
        >
          <div className="accordion_item__header">{t("accountRequirements.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("accountRequirements.item1")}</li>
                <li>{t("accountRequirements.item2")}</li>
                <li>{t("accountRequirements.item3")}</li>
                <li>
                  {t("accountRequirements.item4")}{" "}
                  <a href="mailto:support@bazz.bet" target="_self">
                    support@bazz.bet
                  </a>
                </li>
                <li>
                  {t("accountRequirements.item5")}
                  <ul className="accordion_list">
                    <li>{t("accountRequirements.item5_1")}</li>
                    <li>{t("accountRequirements.item5_2")}</li>
                    <li>{t("accountRequirements.item5_3")}</li>
                  </ul>
                </li>
                <li>{t("accountRequirements.item6")}</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "security" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("security")}
        >
          <div className="accordion_item__header">{t("security.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("security.item1")}</li>
                <li>{t("security.item2")}</li>
                <li>{t("security.item3")}</li>
                <li>{t("security.item4")}</li>
                <li>{t("security.item5")}</li>
                <li>{t("security.item6")}</li>
                <li>{t("security.item7")}</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "deposits" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("deposits")}
          id={"deposits"}
        >
          <div className="accordion_item__header">{t("deposits.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("deposits.item1")}</li>
                <li>
                  {t("deposits.item2")}
                  <ul className="accordion_list">
                    <li>{t("deposits.item2_1")}</li>
                    <li>{t("deposits.item2_2")}</li>
                  </ul>
                </li>
                <li>{t("deposits.item3")}</li>
                <li>{t("deposits.item4")}</li>
                <li>{t("deposits.item5")}</li>
                <li>{t("deposits.item6")}</li>
                <li>{t("deposits.item7")}</li>
                <li>{t("deposits.item8")}</li>
                <li>{t("deposits.item9")}</li>
                <li>{t("deposits.item10")}</li>
                <li>{t("deposits.item11")}</li>
                <li>
                  {t("deposits.item12")}
                  <ul className="accordion_list">
                    <li>{t("deposits.item12_1")}</li>
                    <li>{t("deposits.item12_2")}</li>
                  </ul>
                </li>
                <li>{t("deposits.item13")}</li>
                <li>{t("deposits.item14")}</li>
                <li>{t("deposits.item15")}</li>
                <li>{t("deposits.item16")}</li>
                <li>{t("deposits.item17")}</li>
                <li>{t("deposits.item18")}</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "regulations" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("regulations")}
          id={"regulations"}
        >
          <div className="accordion_item__header">{t("regulations.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("regulations.item1")}</li>
                <li>{t("regulations.item2")}</li>
                <li>{t("regulations.item3")}</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "bonus" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("bonus")}
          id={"bonus"}
        >
          <div className="accordion_item__header">{t("bonuses.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("bonuses.item1")}</li>

                <li id="cashAndBonus">
                  <span>{t("bonuses.item2")}</span>
                  <ul className="accordion_list">
                    <li>{t("bonuses.item2_1")}</li>
                    <li>{t("bonuses.item2_2")}</li>
                    <li>{t("bonuses.item2_3")}</li>
                    <li>{t("bonuses.item2_4")}</li>
                    <li>{t("bonuses.item2_5")}</li>
                    <li>{t("bonuses.item2_6")}</li>
                    <li>{t("bonuses.item2_7")}</li>
                    <li>{t("bonuses.item2_8")}</li>
                    <li>{t("bonuses.item2_9")}</li>
                    <li>{t("bonuses.item2_10")}</li>
                    <li>{t("bonuses.item2_11")}</li>
                    <li>{t("bonuses.item2_12")}</li>
                    <li>{t("bonuses.item2_13")}</li>
                    <li>{t("bonuses.item2_14")}</li>
                  </ul>
                </li>

                <li>
                  <span>{t("bonuses.item3")}</span>
                  <br />
                  <br />
                  {t("bonuses.item3_1")}
                  <br />
                  <br />
                  {t("bonuses.item3_2")}
                  <br />
                  <br />
                  {t("bonuses.item3_3")}
                  <br />
                  <br />
                  {t("bonuses.item3_4")}
                  <br />
                  <br />
                  {t("bonuses.item3_5")}
                  <br />
                  {t("bonuses.item3_6")}
                  <br />
                  <br />
                  {t("bonuses.item3_7")}
                  <br />
                  <br />
                  <b>{t("bonuses.item3_8")}</b>
                  <br />
                  <br />
                  {t("bonuses.item3_9")}
                  <br />
                  <br />
                  {t("bonuses.item3_10")}
                </li>

                <li>
                  {t("bonuses.item4")}
                  <br />
                  <br />
                  {t("bonuses.item4_1")}
                  <br />
                  <br />
                  {t("bonuses.item4_2")}
                  <br />
                  {t("bonuses.item4_3")}
                  <br />
                  {t("bonuses.item4_4")}
                  <br />
                  {t("bonuses.item4_5")}
                  <br />
                  {t("bonuses.item4_6")}
                  <br />
                  <br />
                  {t("bonuses.item4_7")}
                  <br />
                  <br />
                  {t("bonuses.item4_8")}
                  <br />
                  {t("bonuses.item4_9")}
                  <br />
                  {t("bonuses.item4_10")}
                  <br />
                  {t("bonuses.item4_11")}
                  <br />
                  {t("bonuses.item4_12")}
                  <br />
                  <br />
                  <b>{t("bonuses.item4_13")}</b>
                  <br />
                  <br />
                  <b>{t("bonuses.item4_14")}</b>
                  <br />
                  <br />
                  {t("bonuses.item4_15")}
                  <br />
                  <br />
                  <b>{t("bonuses.item4_16")}</b>
                  <br />
                  <br />
                  <b>{t("bonuses.item4_17")}</b>
                  <br />
                  <br />
                  {t("bonuses.item4_18")}
                  <br />
                  {t("bonuses.item4_19")}
                  <br />
                  {t("bonuses.item4_20")}
                  <br />
                  {t("bonuses.item4_21")}
                  <br />
                  <br />
                  <b>{t("bonuses.item4_22")}</b>
                  <br />
                  <br />
                  {t("bonuses.item4_23")}
                  <br />
                  {t("bonuses.item4_24")}
                  <br />
                  {t("bonuses.item4_25")}
                </li>

                <li>
                  {t("bonuses.item5")}
                  <br />
                  <br />
                  {t("bonuses.item5_1")}
                  <br />
                  <br />
                  {t("bonuses.item5_2")}
                  <br />
                  <br />
                  {t("bonuses.item5_3")}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "collusion" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("collusion")}
        >
          <div className="accordion_item__header">{t("collusion.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>
                  {t("collusion.item6_1")}
                  <ul className="accordion_list">
                    <li>{t("collusion.item6_1_1")}</li>
                    <li>{t("collusion.item6_1_2")}</li>
                    <li>{t("collusion.item6_1_3")}</li>
                    <li>{t("collusion.item6_1_4")}</li>
                    <li>{t("collusion.item6_1_5")}</li>
                    <li>{t("collusion.item6_1_6")}</li>
                  </ul>
                </li>

                <li>
                  {t("collusion.item6_2")}
                  <ul className="accordion_list">
                    <li>{t("collusion.item6_2_1")}</li>
                    <li>{t("collusion.item6_2_2")}</li>
                    <li>{t("collusion.item6_2_3")}</li>
                  </ul>
                </li>
                <li>{t("collusion.item6_3")}</li>

                <li>{t("collusion.item6_4")}</li>
                <li>{t("collusion.item6_5")}</li>
                <li>{t("collusion.item6_6")}</li>
                <li>{t("collusion.item6_7")}</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "other-actions-prohibited" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("other-actions-prohibited")}
        >
          <div className="accordion_item__header">{t("prohibitedActions.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("prohibitedActions.item1")}</li>
                <li>{t("prohibitedActions.item2")}</li>
                <li>{t("prohibitedActions.item3")}</li>
                <li>{t("prohibitedActions.item4")}</li>
                <li>{t("prohibitedActions.item5")}</li>
                <li>{t("prohibitedActions.item6")}</li>
                <li>{t("prohibitedActions.item7")}</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "duration-and-cancellation" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("duration-and-cancellation")}
        >
          <div className="accordion_item__header">{t("durationAndCancellation.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("durationAndCancellation.item1")}</li>
                <li>{t("durationAndCancellation.item2")}</li>
                <li>{t("durationAndCancellation.item3")}</li>
                <li>{t("durationAndCancellation.item4")}</li>
                <li>
                  {t("durationAndCancellation.item5_title")}
                  <ul className="accordion_list">
                    <li>{t("durationAndCancellation.item5_1")}</li>
                    <li>{t("durationAndCancellation.item5_2")}</li>
                    <li>{t("durationAndCancellation.item5_3")}</li>
                    <li>{t("durationAndCancellation.item5_4")}</li>
                    <li>{t("durationAndCancellation.item5_5")}</li>
                    <li>{t("durationAndCancellation.item5_6")}</li>
                  </ul>
                </li>
                <li>{t("durationAndCancellation.item6")}</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "changes-in-the-website" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("changes-in-the-website")}
          id={"changes-in-the-website"}
        >
          <div className="accordion_item__header">{t("changesInTheWebsite.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">{t("changesInTheWebsite.item1")}</div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "system-errors" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("system-errors")}
          id={"system-errors"}
        >
          <div className="accordion_item__header">{t("systemErrors.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">{t("systemErrors.item1")}</div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "errors-or-defects" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("errors-or-defects")}
        >
          <div className="accordion_item__header">{t("errorsOrDefects.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("errorsOrDefects.item1")}</li>
                <li>{t("errorsOrDefects.item2")}</li>
                <li>{t("errorsOrDefects.item3")}</li>
                <li>{t("errorsOrDefects.item4")}</li>
                <li>{t("errorsOrDefects.item5")}</li>
                <li>{t("errorsOrDefects.item6")}</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "limitation-of-liability" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("limitation-of-liability")}
        >
          <div className="accordion_item__header">{t("limitationOfLiability.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("limitationOfLiability.item1")}</li>
                <li>
                  {t("limitationOfLiability.item2")}
                  <ul className="accordion_list">
                    <li>{t("limitationOfLiability.item2_1")}</li>
                    <li>{t("limitationOfLiability.item2_2")}</li>
                    <li>{t("limitationOfLiability.item2_3")}</li>
                    <li>{t("limitationOfLiability.item2_4")}</li>
                    <li>{t("limitationOfLiability.item2_5")}</li>
                  </ul>
                </li>
                <li>{t("limitationOfLiability.item3")}</li>
                <li>{t("limitationOfLiability.item4")}</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "violation-of-terms" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("violation-of-terms")}
        >
          <div className="accordion_item__header">{t("violationOfTerms.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("violationOfTerms.item1")}</li>
                <li>
                  {t("violationOfTerms.item2")}
                  <ul className="accordion_list">
                    <li>{t("violationOfTerms.item2_1")}</li>
                    <li>{t("violationOfTerms.item2_2")}</li>
                    <li>{t("violationOfTerms.item2_3")}</li>
                    <li>{t("violationOfTerms.item2_4")}</li>
                  </ul>
                </li>
                <li>
                  {t("violationOfTerms.item3")}
                  <ul className="accordion_list">
                    <li>{t("violationOfTerms.item3_1")}</li>
                    <li>{t("violationOfTerms.item3_2")}</li>
                    <li>{t("violationOfTerms.item3_3")}</li>
                    <li>{t("violationOfTerms.item3_4")}</li>
                  </ul>
                </li>
                <li>{t("violationOfTerms.item4")}</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "intellectual-property-rights" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("intellectual-property-rights")}
        >
          <div className="accordion_item__header">{t("intellectualPropertyRights.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("intellectualPropertyRights.item1")}</li>
                <li>{t("intellectualPropertyRights.item2")}</li>
                <li>{t("intellectualPropertyRights.item3")}</li>
                <li>{t("intellectualPropertyRights.item4")}</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`accordion_item ${activeMenu === "personal-data-protection" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("personal-data-protection")}
        >
          <div className="accordion_item__header">{t("personalDataProtection.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">
              <ul className="accordion_list">
                <li>{t("personalDataProtection.item1")}</li>
                <li>{t("personalDataProtection.item2")}</li>
                <li>{t("personalDataProtection.item3")}</li>
                <li>{t("personalDataProtection.item4")}</li>
                <li>
                  {t("personalDataProtection.item5")}
                  <ul className="accordion_list">
                    <li>{t("personalDataProtection.item5_1")}</li>
                    <li>{t("personalDataProtection.item5_2")}</li>
                    <li>{t("personalDataProtection.item5_3")}</li>
                    <li>{t("personalDataProtection.item5_4")}</li>
                  </ul>
                </li>
                <li>{t("personalDataProtection.item6")}</li>
                <li>{t("personalDataProtection.item7")}</li>
                <li>{t("personalDataProtection.item8")}</li>
                <li>{t("personalDataProtection.item9")}</li>
                <li>{t("personalDataProtection.item10")}</li>
                <li>{t("personalDataProtection.item11")}</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "cookies" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("cookies")}
        >
          <div className="accordion_item__header">{t("cookies.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">{t("cookies.item")}</div>
          </div>
        </div>
        <div
          className={`accordion_item ${activeMenu === "links" ? "open" : ""}`}
          onClick={() => handlerActiveMenu("links")}
        >
          <div className="accordion_item__header">{t("links.title")}</div>

          <div className="accordion_item__inner">
            <div className="accordion_item__text">{t("links.text")}</div>
          </div>
        </div>
      </div>
    </>
  );
}
